import styled from 'styled-components';

export const Body = styled.div`
  padding: 16px 24px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const SectionLabel = styled.div`
  display: flex;
  gap: 2px;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;

  span {
    color: ${({ theme }) => theme.colors.surface.onSurface};
  }

  strong {
    color: ${({ theme }) => theme.colors.danger.danger};
  }
`;

export const OrientationOptions = styled.div`
  display: flex;
  gap: 4px;
`;

export const OrientationOption = styled.button<{ selected: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  padding: 10px;
  border: 1px solid ${({ theme, selected }) => selected
        ? theme.colors.primary.primary
        : theme.colors.surface.surfaceOutline};
  background-color: ${({ theme, selected }) => selected
        ? `color-mix(in srgb, ${theme.colors.primary.primaryHover}, ${theme.colors.surface.surface})`
        : theme.colors.surface.surface};
  cursor: pointer;

  .orientationIcon {
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
    flex-shrink: 0;
  }

  .orientationIconLandscape {
    transform: rotate(90deg);
  }
`;

export const StyledRadio = styled.div`
  display: flex;

  .ant-radio-wrapper {
    margin-inline-end: 0;
  }

  .ant-radio {
    top: 0;
  }
`;

export const OrientationLabel = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.surface.onSurface};
`;

export const StyledCheckbox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  .ant-checkbox-wrapper {
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.surface.onSurface};
    font-size: 12px;
    line-height: 16px;
  }

  .ant-checkbox {
    top: 0;
  }

  .ant-checkbox-inner {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    border-color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder};
  }
`;

export const ActivitiesOption = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

export const ActivitiesRadioLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  color: ${({ theme }) => theme.colors.surface.onSurface};
  font-size: 12px;
  line-height: 16px;
`;

export const ActivitiesTag = styled.span`
  min-width: 16px;
  padding: 2px 4px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.secondary.secondary};
  color: ${({ theme }) => theme.colors.surface.onSurface};
  font-size: 10px;
  font-weight: 600;
  line-height: 12px;
  text-align: center;
`;

export const FooterDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.surface.surfaceOutline};
`;

export const FooterButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;

  .buttonCancel,
  .buttonPrint {
    height: 32px;
    font-size: 12px;
    line-height: 16px;
    border-radius: 6px;
    padding: 8px 12px;
  }

  .buttonPrint {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .buttonPrintIcon {
    font-size: 14px;
  }
`;
